export const notifyPartnersDividendsModalInitValue = {
  data: {
    partnersData: [],
    totalPartners: 0,
    expandView: false,
    expandDirection: 'down',
    hasInvalidEmails: false,
    invalidEmailsAlert: undefined,
    hasGeneratedEmails: false,
    generatedEmailsAlert: undefined,
    showTestEmailPanel: false,
    testEmailRecipient: '',
    invalidEmail: false,
    currentPage: 1,
    rowsPerPage: 10,
    isLoading: false,
    showBounceRetryWarning: false,
    bounceRetryAllowedEmails: [],
  },
  actions: {
    handleChangeView: () => undefined,
    handleCloseModal: () => undefined,
    handleSendEmails: () => undefined,
    handleSendTestEmail: () => undefined,
    handleToggleTestEmailPanel: () => undefined,
    handleChangeTestEmailRecipient: (_email: string) => undefined, // eslint-disable-line
    handleChangePage: (_page: number) => undefined, // eslint-disable-line
    handleChangeRowsPerPage: (_rowsPerPage: number) => undefined, // eslint-disable-line
  },
};
